/*----------------------------------
- MENU COUNT ROW
----------------------------------*/

/*----------------------------------
- TYPES
----------------------------------*/

type MenuCountRowProps = {
    href: string;
    label: string;
    /** Formatted backend count. Null when Product sent none: the row then shows the label alone. */
    count: string | null;
    /**
     * `row` (default) is a sector: the name at the left, its count at the right (`a.mc`). `cell` is an ending in the
     * three-across grid: the ending in ink at 16px heavy over its count (`a.me`, web-recheck-01).
     */
    look?: 'row' | 'cell';
    ariaLabel?: string;
    onClick?: () => void;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/** One ending or one sector in the Domains menu: its name and the count Product sent. */
export default function MenuCountRow({ href, label, count, look = 'row', ariaLabel, onClick }: MenuCountRowProps) {
    return (
        <a href={href} onClick={onClick} aria-label={ariaLabel} class={look === 'cell' ? 'me' : 'mc'}>
            <b>{label}</b>
            {count ? <span>{count}</span> : null}
        </a>
    );
}
